import * as INR from "./INR.ts";
import * as i18n from "./i18n.ts";
import * as FwDatas from "./FwDatas.ts";
import ApiServer from "./ApiServer.js";
import * as libLocation from "./lib/location.ts";
import {openStorageAlert} from "./modal/storageAlert.js"
import * as Storage from "./lib/Storage.ts";
import * as Html from "./util/Html.ts";
var 
  needToCheckSafariCookie = true,
  lastAskedLanguage=null;

function openPremiumPopup(){
  setTimeout(function(){Html.trigger('takepremium',['directclick'])},1000)
  
}


function resetThen(next) {
  return function(callback) {
    FwDatas.reset();
    next(callback, {}); // reset current data to an empty object
  };
}


function ensureSafariCookieThen(next) {
  return function(callback) {
    if(!navigator.cookieEnabled){
      ApiServer.usejessionidinurl = true;
    }
    //if it has not been done before and that there is a chance for browser to be safari
    if (needToCheckSafariCookie && !ApiServer.usejessionidinurl) {
      //we get the variable "a"
      function onError(){
        next(callback, {error:true});
      }
      var val = "t";
      ApiServer.webset("a",val,function(){
        ApiServer.webget("a",function(a) {
          needToCheckSafariCookie = false;
          if (a!=val) {
            //here we have been redirected but the data is not setted
            ApiServer.usejessionidinurl = true;
            console.log("ERROR : no cookie");
            ApiServer.webjslog("ERROR : no cookie use jsessionid");
            //we keep going maybe it will works next time
            next(callback, {});
          } else {
            //its ok we have get via ajax something putted by direct call, so the session is ok
            next(callback, {});
          }
        },onError)
      },onError)
      
    } else {
      next(callback, {});
    }
  };
}

function controlPush(next){
  return function(callback){
    var 
      params = libLocation.getURLParams(),
      push = params.push;
    if(!push){
      //deeplink
      if(params.TK){
        Storage.sessionSet('logfromdeeplink','true')
        ApiServer.log2deeplink(params.TK,params.fid,function(){
          if(params.tp==='map'){
            libLocation.goTo('map.php',true,true); 
          }else{
            libLocation.clearParamInHistory(); 
            next(callback, {});
          }
        },function(){
          libLocation.goTo('error_token.php',true,true); 
        });
        
      }else{
        next(callback, {});
      }
      
    }else{
      
      var whenLoggedToGoodFamily;
      var modalFunction = {
        QuotaAlmostExceeded:openStorageAlert,
        QuotaExceeded:openStorageAlert,
        Promo:openPremiumPopup
      }[push]
      if(modalFunction){
        whenLoggedToGoodFamily = function(){
          modalFunction()
          next(callback, {});
        }
      }else{
        whenLoggedToGoodFamily = function(){
          var url = { 
            New_Message:'im.php', //new message in the chat
            New_Event:'events.php',      //new event created posted on the wall
            Update_Event:'events.php',     //event updated posted on the wall
            Event_Reminder:'events.php',   //event reminder -> in snooze mode an event is ringing through notification, it is triggered by alarmengine
            Task_Reminder:'tasks.php',    //task reminder -> in sniize mode a task is ringing through notification, it is triggered by alarmengine
            KidsAtHome:'map.php', //kids@home notification geofencing
            GeoFencingIn:'map.php', //geofencing auto movetype=in happened, broadcasted to all subscribers
            GeoFencingOut:'map.php', //geofencing auto movetype=out happened, broadcasted to all subscribers
            GeolocAutotrackRequest:'map.php', //push notif to indicate somebody has requested your geolocalisation for a specific family (from the map screen -> autotracking always requested)
            GeolocAutotrackAccepted:'map.php',
            GeolocAutotrackDeclined:'map.php',
            AlarmPanicButton:'map.php',
            AlamPanicCleared:'map.php',
            GeolocFencingRequest:'map.php',
            GeolocFencingNewPlace:'map.php',
            GeolocPositionRefreshRequest:'map.php',
            GeolocPositionRefreshResponse:'map.php',
            GeolocPositionRefreshError:'map.php',
            TaskListContentModified:'tasks.php',
            TimetableCreate:'timetable.php',
            TimetableUpdate:'timetable.php',
            TimetableReminder:'timetable.php'
            
          }[push]||INR.URL.ENTER_HOME;
          //ideally the next should be shortcutted, but it does not work because of onParamChange, so we do it
          next(callback, {});
          libLocation.goTo(url+(params.targetId?("?metaId="+encodeURIComponent(params.targetId)):"")  ,true);
        }
      }
      
      
      if(params.familyId){
        ApiServer.famlogfamily(params.familyId,whenLoggedToGoodFamily,whenLoggedToGoodFamily);
      }else{
        whenLoggedToGoodFamily();
      }
      
      
      
    }
  }
}    

/*
 * Function: loadLanguagePropertiesThen(next) Load language properties for
 * localization in a chain of actions
 * 
 * Parameter: next - function(callback), the next action to call, with the
 * callback function as parameter
 * 
 * Returns: function(callback,data), the action that loads language
 * properties and starts the next action, forwarding the callback and
 * current data
 * 
 * Note: This function is called in all pages whereas
 * loadExtraLanguagePropertiesThen is only called when the user is
 * logged-in.
 */
function loadLanguagePropertiesThen(next) {
  return function(callback, data) {
    var 
      currentUser = FwDatas.getUser(),
      language = libLocation.getURLParam('lang') || (currentUser ? currentUser.languageCode : undefined);

    if(lastAskedLanguage===language){
      next(callback, data);
      return;
    }else{
      lastAskedLanguage=language;
    }
    
    //clean of language that might be like "en_us_#u_FW"
    var cleanLanguage = undefined;
    if(language!==undefined){
      cleanLanguage = language.split(/-|_/g).slice(0,2).join('-')
      try{
        //it will be used later, so we check if it will work
        new Intl.NumberFormat(cleanLanguage);
      }catch(e){
        ApiServer.webjslog('Bad language code '+language + " Fallback to en-us")
        cleanLanguage = 'en-us'
      }
    }
    
    i18n.selectLanguage(cleanLanguage);
    
    i18n.loadLanguage();
    next(callback, data);
    
  };
}


/*
 * Function: endOfChain(callback,data) Trigger the callback at the end of
 * a chain of actions
 * 
 * Parameters: callback - function(data), the callback function to trigger
 * at the end of the chain, providing current data as argument data -
 * object, current data
 */
function endOfChain(callback, data) {
  callback(data);
}
function getStartSequence(isLogged, end) {
  end = end || endOfChain;
  return loadLanguagePropertiesThen(ensureSafariCookieThen(controlPush(resetThen(end))));
}

export {
  ensureSafariCookieThen,
  controlPush,
  resetThen,
  loadLanguagePropertiesThen,
  getStartSequence
};